export const EVENT_REFUND_POLICY = {
  SEVEN_DAY: '7_day',
  THREE_DAY: '3_day',
  ONE_DAY: '1_day',
};

export const REFUND_POLICY_OPTIONS = [
  { value: EVENT_REFUND_POLICY.SEVEN_DAY, label: 'Up to 7 days before event' },
  { value: EVENT_REFUND_POLICY.THREE_DAY, label: 'Up to 3 days before event' },
  { value: EVENT_REFUND_POLICY.ONE_DAY, label: 'Up to 1 day before event' },
];

const LEGACY_REFUND_POLICY_MAP = {
  '7_days_before': EVENT_REFUND_POLICY.SEVEN_DAY,
  '3_days_before': EVENT_REFUND_POLICY.THREE_DAY,
  '24_hours_before': EVENT_REFUND_POLICY.ONE_DAY,
};

export const normalizeRefundPolicy = (value) => {
  if (!value) return EVENT_REFUND_POLICY.SEVEN_DAY;
  if (Object.values(EVENT_REFUND_POLICY).includes(value)) return value;
  return LEGACY_REFUND_POLICY_MAP[value] ?? EVENT_REFUND_POLICY.SEVEN_DAY;
};

export const getRefundPolicyLabel = (value) =>
  REFUND_POLICY_OPTIONS.find((option) => option.value === normalizeRefundPolicy(value))?.label ??
  value ??
  '—';
